/**
 * A service providing preset date ranges for the angular-daterangepicker
 * and datetimepicker directives
 */
angular.module('app').factory('DateRangeService', function () {
    // TODO: Set start time to 00:00 and end time to 23:59:59
    const ranges = [
        {
            name: 'Today',
            start: moment()
                .subtract(1, 'days')
                .add(1, 'days')
                .startOf('days'),
            end: moment()
                .subtract(0, 'days')
                .endOf('days')
        },
        {
            name: 'Yesterday',
            start: moment()
                .subtract(1, 'days')
                .startOf('days'),
            end: moment()
                .subtract(1, 'days')
                .endOf('days')
        },
        {
            name: 'Last 7 Days',
            start: moment()
                .subtract(6, 'days')
                .startOf('days'),
            end: moment().endOf('days')
        },
        {
            name: 'Last 30 Days',
            start: moment()
                .subtract(29, 'days')
                .startOf('days'),
            end: moment().endOf('days')
        },
        {
            name: 'This Month',
            start: moment()
                .startOf('month')
                .startOf('days'),
            end: moment()
                .endOf('month')
                .endOf('days')
        },
        {
            name: 'Last Month',
            start: moment()
                .subtract(1, 'month')
                .startOf('month')
                .startOf('days'),
            end: moment()
                .subtract(1, 'month')
                .endOf('month')
                .endOf('days')
        }
    ];
    let fac = {
        ranges: ranges
    };
    return fac;
});
